import { render, staticRenderFns } from "./UserProfileChangeEmail.vue?vue&type=template&id=2079b450&scoped=true&"
import script from "./UserProfileChangeEmail.vue?vue&type=script&lang=js&"
export * from "./UserProfileChangeEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079b450",
  null
  
)

export default component.exports